import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Calendar, Badge, Row, Col, Button, Icon, Modal } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Switchbox from '../../../../components/user/from/Switchbox'
import Container from '../../../../components/user/Container'
import { monthDataSet } from '../../../../config/datasets'
import { UrlMeeting } from '../../../../utils/auth'
import ListCalendarMeeting from '../../../../components/user/from/MeetingManagement/ListCalendarMeeting'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import moment from "moment/min/moment-with-locales";
import axios from 'axios';
import { changeYear } from '../../../../utils/formatdate'
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";

const { Text, Title } = Typography

class MeetingManagement extends React.Component {

    state = {
        nowMonth: Number(moment().format('MM')),
        nowYear: moment().format('YYYY'),
        nowDate: moment().format('DD'),
        date: moment().locale('th'),
        nextArrow: true,
        prevArrow: false,
        showModalCreate: false,
        reqApprove: false,
        reqNote: false,
        dataMeeting: [],
    }

    componentDidMount = () => {
        // console.log("nowMonth",this.state.nowMonth);
        this.fetchListMeeting(sessionStorage.getItem('username'), moment().format('YYYY-MM'));
    }

    fetchListMeeting = (UserID, MonthYear) => {
         axiosAPI.post(`${UrlMeeting()}/meeting/secure/listMeetinginMonth`,
            {
                UserID: UserID,
                MonthYear: MonthYear
            })
            .then(response => {
                const data = response.data.status.message.Date
                this.setState({
                    dataMeeting: data
                })
                // console.log("response",response);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    next = async () => {
        var _date = moment(this.state.date).subtract(-1, 'months').startOf('month')
        this.fetchListMeeting(sessionStorage.getItem('username'), _date.format('YYYY-MM'));

        let calendarDate = moment();
        if (calendarDate.month() === _date.month()) {
            _date = calendarDate;
        }

        await this.setState({
            date: _date,
            nowMonth: Number(_date.format('MM')),
            nowYear: _date.format('YYYY'),
            nowDate: _date.format('DD'),
        })
    }

    previous = async () => {
        var _date = moment(this.state.date).subtract(1, 'months').startOf('month')
        this.fetchListMeeting(sessionStorage.getItem('username'), _date.format('YYYY-MM'));

        let calendarDate = moment();
        if (calendarDate.month() === _date.month()) {
            _date = calendarDate;
        }

        await this.setState({
            date: _date,
            nowMonth: Number(_date.format('MM')),
            nowYear: _date.format('YYYY'),
            nowDate: _date.format('DD'),
        })
    }
    getListData = (value) => {
        let listData = [];
        this.state.dataMeeting.forEach(element => {
            if (moment(element.startdate).format('DD-MM-YYYY') == value.format('DD-MM-YYYY')) {
                listData.push({ color: (element.status == "Waiting" ? "#faad14" : (element.status == "Join" ? "#178991" : (element.status == "Refuse" ? "#d94339" : "#cccccc"))) });
            }
        });
        return listData || [];
    }

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        return (
            <>
                <div style={{ display: 'flex', height: '55px', alignItems: 'flex-end', paddingLeft: '15px', paddingRight: '15px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {listData.map((item, i) => (
                            <>
                                {i < 5 ?
                                    <Badge key={item.meetingID} color={item.color} />
                                    :
                                    <></>
                                }
                            </>
                        ))}
                    </div>
                </div>
            </>
        );
    }

    getMonthData = (value) => {
        if (value.month() === 8) {
            return 1394;
        }
    }

    monthCellRender = (value) => {
        // console.log("monthCellRender", value);
        const num = this.getMonthData(value);
        return num ? (
            <div className="notes-month">
                <section>{num}</section>
            </div>
        ) : null;
    }

    onChangeCalendar = async (value, mode) => {
        // console.log("value",value);
        const valueDate = moment(value);
        this.setState({
            date: valueDate,
            nowDate: valueDate.format('DD'),
            nowMonth: valueDate.format('MM'),
            nowYear: valueDate.format('YYYY')
        })
    };
    onSelect = value => {
        this.setState({
            value,
            selectedValue: value,
        });
    };

    handleCancel = () => {
        this.setState({
            showModalCreate: false,
        })
    }


    handleOpenCreate = () => {
        this.setState({
            showModalCreate: true,
        })
    }

    changeApproveSwitch = async (e) => {
        await this.setState({
            reqApprove: e,
        })
    }
    changeNoteSwitch = async (e) => {
        await this.setState({
            reqNote: e,
        })
    }


    render() {
        const { match } = this.props

        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}

                <Modal
                    title="สร้างการประชุมใหม่"
                    className={'meeting-management-modal'}
                    visible={this.state.showModalCreate}
                    onCancel={this.handleCancel}
                    footer={[
                        // <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                        //     ยกเลิก</Button>,

                        <Link
                            to={{
                                pathname: '/meetingmanagement/createMeetingForm/',
                                search: 'approve=' + (this.state.reqApprove ? "yes" : "no") + '&note=' + (this.state.reqNote ? "yes" : "no") + '&from=/meetingmanagement/meeting',
                            }}>
                            <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleCancel}>
                                สร้างการประชุม</Button>
                        </Link>,
                    ]}
                >
                    <Row gutter={16} type="flex">
                        <Col xs={24} >
                            <Switchbox
                                onChange={this.changeApproveSwitch}
                                inModal={true}
                                fontSize="16px"
                                label="การประชุมที่ต้องมีการขออนุมัติ"
                                textToolTip="เมื่อเลือกการประชุมประเภทที่ต้องมีการขออนุมัติ แล้วกด “ส่งขออนุมัติ“ ระบบจะส่งการประชุมนี้ให้ผู้ที่มีสิทธิอนุมัติ ทำการอนุมัติ หลังจากนั้นระบบจึงจะส่งเชิญประชุมให้กับผู้ที่เชิญโดยอัตโนมัติ" />
                        </Col>
                        <Col xs={24} >
                            <Switchbox
                                onChange={this.changeNoteSwitch}
                                inModal={true}
                                fontSize="16px"
                                label="การประชุมที่ต้องมีการส่งบันทึกและแสดงความเห็นชอบ"
                                textToolTip="เมื่อเลือกการประชุมประเภทที่ต้องส่งบันทึกและแสดงความเห็นชอบ หลังจากผู้สร้างการประชุมส่งบันทึกการประชุม ระบบจะแจ้งเตือนให้ผู้ถูกเชิญสามารถแสดงความเห็นชอบหรือความคิดเห็นการประชุมได้" />
                        </Col>
                    </Row>
                </Modal>


                <div className="card-container calendar-meeting">
                    <div className="card-bg-white">
                        <div className="px-5">
                            <Row gutter={16} className={'py-4'}>
                                <Col xs={24} xl={8} style={{ marginTop: '70px' }} >
                                    <Row gutter={16} type="flex">
                                        <Col xs={16} >
                                            <p style={{ marginBottom: '0px' }} className='title-calendar-meeting'>{this.state.nowDate} {monthDataSet[this.state.nowMonth - 1]}</p>
                                        </Col>
                                        <Col xs={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button onClick={this.handleOpenCreate} className={'button-meeting-add-calendar p-0 px-3'} >
                                                <Icon type="plus" /> สร้าง
                                            </Button>
                                        </Col>
                                    </Row>
                                    <div className='px-2 mt-3' style={{ height: 750, overflowY: "scroll" }}>
                                        <Row gutter={16} type="flex">
                                            <Col xs={24} >
                                                รายการประชุมที่ถูกเชิญ
                                            </Col>
                                            <Col xs={24}>
                                                <ListCalendarMeeting dataMeeting={this.state.dataMeeting} date={this.state.date.format('DD-MM-YYYY')} typeMeeting="Waiting"></ListCalendarMeeting>
                                            </Col>
                                            <Col className={'pt-3'} xs={24} >
                                                รายการประชุมที่ตอบรับแล้ว
                                            </Col>
                                            <Col xs={24} >
                                                <ListCalendarMeeting dataMeeting={this.state.dataMeeting} date={this.state.date.format('DD-MM-YYYY')} typeMeeting="Join"></ListCalendarMeeting>
                                            </Col>
                                            <Col className={'pt-3'} xs={24} >
                                                รายการประชุมที่ปฏิเสธ
                                            </Col>
                                            <Col xs={24} >
                                                <ListCalendarMeeting dataMeeting={this.state.dataMeeting} date={this.state.date.format('DD-MM-YYYY')} typeMeeting="Refuse"></ListCalendarMeeting>
                                            </Col>
                                            <Col className={'pt-3'} xs={24} >
                                                รายการประชุมที่ส่งตัวแทน
                                            </Col>
                                            <Col xs={24} >
                                                <ListCalendarMeeting dataMeeting={this.state.dataMeeting} date={this.state.date.format('DD-MM-YYYY')} typeMeeting="Agent"></ListCalendarMeeting>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col xs={24} xl={16}>
                                    <p className='title-calendar-meeting'>
                                        <Button
                                            className="px-2"
                                            onClick={this.previous}
                                        >
                                            <Icon type="left" />
                                        </Button>
                                        <Button
                                            className="px-2"
                                            onClick={this.next}
                                        >
                                            <Icon type="right" />
                                        </Button>
                                        {monthDataSet[this.state.nowMonth - 1]} {changeYear(parseInt(this.state.nowYear))}
                                    </p>
                                    <Calendar
                                        dateCellRender={this.dateCellRender}
                                        onSelect={(value) =>
                                            this.onChangeCalendar(value)
                                        }
                                        monthCellRender={this.monthCellRender}
                                        headerRender={() => null}
                                        value={this.state.date}
                                        mode='month'
                                        locale={{
                                            lang: {
                                                locale: 'en',
                                                dayFormat: moment.updateLocale('en', {
                                                    weekdaysMin: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.']
                                                })
                                            }
                                        }}


                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </Container>
        )
    }
}

MeetingManagement.propTypes = {
    //
}



export default withApollo(MeetingManagement)